import { CloseButton, Modal } from "react-bootstrap";
import {
  GetModalDevicesTabDetailsProcess,
  GetProcessesPerformanceDetailsProcess,
} from "../../client/AuthedClient";
import { TabbedContainer } from "../TabbedContainer";
import {
  ApplicationPerformanceDevicesModal,
  ApplicationPerformanceFailuresModal,
} from "./";
import { useState } from "react";

export const ApplicationPerformanceModal = (props: {
  showModal: boolean;
  onHide: () => void;
  modalTitle: string;
  details: Array<GetProcessesPerformanceDetailsProcess>;
  devicesDetails: Array<GetModalDevicesTabDetailsProcess>;
}) => {
  const [tabId, setTabId] = useState<any>();
  const { showModal, onHide, modalTitle } = props;

  return (
    <Modal
      keyboard={false}
      centered={true}
      scrollable={true}
      show={showModal}
      onHide={() => onHide()}
      size="lg"
    >
      <div className="app-performance-modal">
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
          <CloseButton onClick={() => onHide()} />
        </Modal.Header>
        <TabbedContainer
          tabs={[
            {
              title: "Devices",
              body: ApplicationPerformanceDevicesModal(props, tabId),
            },
            {
              title: "Failures",
              body: ApplicationPerformanceFailuresModal(props, tabId),
            },
          ]}
          setTabId={setTabId}
        />
      </div>
    </Modal>
  );
};
